<template>
<v-container class="pt-0 pb-12 py-sm-12">

    <!-- Header Desktop -->
    <v-row class="d-none d-sm-flex">
      <v-col cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">Preço Dinâmico</span>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
              { text: 'Homepage', disabled: false, to: '/home', exact: true },
              { text: 'Preço Dinâmico', disabled: true, exact: true }
            ]" />
          </div>
          <div class="button-group">
            <v-btn elevation="0" color="primary" dark @click="abrirFormulario" :loading="dataList.loading">
              <v-icon class="mr-2" size="large">mdi-plus</v-icon>
              Adicionar
            </v-btn>
            <v-btn elevation="0" color="primary" outlined dark @click="loadData" :loading="dataList.loading">
              <v-icon class="mr-2" size="large">mdi-refresh</v-icon>
              Atualizar
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

<!-- Header Mobile -->
    <v-row class="d-sm-none mb-4">
      <v-col cols="12">
        <div class="title-container">
          <div class="title-block">
            <span class="page-title">Preço Dinâmico</span>
            <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
  { text: 'Homepage', disabled: false, to: '/home', exact: true },
  { text: 'Preço Dinâmico', disabled: true, exact: true }
]" />
          </div>
        </div>
        <div class="button-group mt-2">
          <v-btn elevation="0" color="primary" dark @click="abrirFormulario" :loading="dataList.loading">
            <v-icon class="mr-2" size="large">mdi-plus</v-icon>
            Adicionar
          </v-btn>
          <v-btn elevation="0" color="primary" outlined dark @click="loadData" :loading="dataList.loading">
            <v-icon class="mr-2" size="large">mdi-refresh</v-icon>
            Atualizar
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- Tabela -->
   <v-row>
  <v-col cols="12">
<v-data-table
  :headers="dataList.headers"
  :items="dataList.data"
  :server-items-length="dataList.count"
  :disable-sort="true"
  :loading="dataList.loading"
  no-data-text="Nenhum preço dinâmico foi encontrado"
  loading-text="Carregando dados..."
  class="app-table hover-table preco-dinamico-table"
  :options.sync="dataList.options"
  :footer-props="dataList.footerOptions"
  :hide-default-footer="$vuetify.breakpoint.xsOnly"
  @update:items-per-page="pageSizeChanged"
  @update:page="pageChanged"
>
      <template v-slot:[`item.dataInicio`]="{ item }">
        {{ item.dataInicio ? item.dataInicio.split('-').reverse().join('/') : '-' }}
      </template>

      <template v-slot:[`item.dataFim`]="{ item }">
        {{ item.dataFim ? item.dataFim.split('-').reverse().join('/') : '-' }}
      </template>

      <template v-slot:[`item.horaInicio`]="{ item }">
        {{ item.horaInicio }}
      </template>

      <template v-slot:[`item.horaFim`]="{ item }">
        {{ item.horaFim }}
      </template>

    <template v-slot:[`item.diaDaSemana`]="{ item }">
  {{ Array.isArray(item.diaDaSemana) && item.diaDaSemana.length
    ? item.diaDaSemana.map((x) => x.substring(0, 3)).join(", ")
    : "-" }}
</template>

      <template v-slot:[`item.maquinas`]="{ item }">
        <span v-if="item.maquinas && item.maquinas.length">
          {{ item.maquinas.map(function(m) { return m.nome }).join(', ') }}
        </span>
        <span v-else style="color:#aaa;">-</span>
      </template>

      <template v-slot:[`item.valor`]="{ item }">
        {{ item.valor ? 'R$\u00a0' + parseFloat(item.valor).toFixed(2).replace('.', ',') : '-' }}
      </template>

    <template v-slot:[`item.actions`]="{ item }">
       <div class="d-flex justify-center actions-gap-desktop">
  <v-btn color="primary-200" small class="action-btn-fixed" @click="editarItem(item)">
    <v-icon left>mdi-pencil-outline</v-icon>
    Editar
  </v-btn>
 <v-btn small class="action-btn-fixed" style="background-color: #f44336 !important; color: white !important;" @click="confirmarExclusao(item)">
  <v-icon left>mdi-delete-outline</v-icon>
  Excluir
</v-btn>
</div>
      </template>
    </v-data-table>
    <div class="lista-custom-pagination d-flex d-sm-none">
  <div class="lista-pagination-topo">
    <v-select
      :items="[10, 20]"
      v-model="dataList.options.size"
      dense
      outlined
      hide-details
      class="lista-itens-por-pagina"
      @change="pageSizeChanged(dataList.options.size)"
    />
    <span class="lista-pagination-label">
      Página {{ dataList.options.page }} de {{ totalPaginasLista }}
    </span>
  </div>
  <div class="lista-pagination-botoes">
    <v-btn text small color="primary" :disabled="dataList.options.page <= 1" @click="paginaAnteriorLista">
      <v-icon left small>mdi-chevron-left</v-icon>
      Anterior
    </v-btn>
    <v-btn text small color="primary" :disabled="dataList.options.page >= totalPaginasLista" @click="paginaProximaLista">
      Próxima
      <v-icon right small>mdi-chevron-right</v-icon>
    </v-btn>
  </div>
</div>

    <div style="font-size:12px; color:#e53935; margin-top:8px; padding: 0 4px;">
      * Ao cadastrar dois preços dinâmicos para a mesma máquina, mesmo intervalo de datas e horários, o sistema considerará apenas o primeiro cadastrado.
    </div>
    <v-divider />
  </v-col>
</v-row>

     <!-- Dialog Confirmação Exclusão -->
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card>
        <v-card-title class="text-h6">Excluir Preço Dinâmico</v-card-title>
        <v-card-text>Deseja realmente excluir este preço dinâmico?</v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="dialogExcluir = false">Cancelar</v-btn>
          <v-btn style="background-color: #f44336 !important; color: white !important;" @click="excluirItem">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" top right>
      {{ snackbar.text }}
    </v-snackbar>

  </v-container>
</template>

<script>
import axios from 'axios';
import { eventHub } from "@/main";

export default {
  name: 'PrecoDinamicoList',

    data: function() {
  return {
    maquinasOpcoes: [],
    dataset: {
      operation: null
    },
    dataList: {
  headers: [
 { text: 'Data de início',     value: 'dataInicio', width: '80px' },
  { text: 'Data de término',    value: 'dataFim', width: '95px' },
  { text: 'Horário de início',  value: 'horaInicio', width: '95px' },
  { text: 'Horário de término', value: 'horaFim', width: '95px' },
 { text: 'Dias da semana',     value: 'diaDaSemana', width: '85px' },
  { text: 'Máquinas',           value: 'maquinas', width: '90px' },
  { text: 'Valor',              value: 'valor', width: '90px' },
  { text: 'Ações',              value: 'actions', sortable: false, align: 'center', width: '190px' },
],
      data: [],
      loading: false,
      count: 0,
      options: {
        page: 1,
        size: 10,
      },
     footerOptions: {
  itemsPerPageText: 'Itens por página:',
  itemsPerPageOptions: [10, 20],
  pageText: '{0}-{1} de {2}',
}
    },
    dialogFormulario: false,
    dialogExcluir: false,
    itemSelecionado: null,
    itemParaExcluir: null,
    snackbar: {
      show: false,
      text: '',
      color: 'success'
    }
  };
},

computed: {
  totalPaginasLista() {
    const total = this.dataList.count || 0;
    const porPagina = this.dataList.options.size || 10;
    return Math.max(1, Math.ceil(total / porPagina));
  }
},


mounted: function() {
  this.dataset.operation = localStorage.getItem('operation');
  this.carregarMaquinas();
  this.loadData();

  var self = this;
  eventHub.$on('CHANGE-OPERATION', function() {
    self.dataset.operation = localStorage.getItem('operation');
    self.dataList.data = [];
    self.dataList.count = 0;
    self.dataList.options.page = 1;
    self.carregarMaquinas();
    self.loadData();
  });
}, 

destroyed: function() {
  eventHub.$off('CHANGE-OPERATION');
},


  methods: {
    loadData: function() {
      this.load();
    },

    paginaAnteriorLista() {
      if (this.dataList.options.page > 1) {
        this.dataList.options.page--;
        this.load();
      }
    },

    paginaProximaLista() {
      if (this.dataList.options.page < this.totalPaginasLista) {
        this.dataList.options.page++;
        this.load();
      }
    },

    agruparDias(dias) {
  const abreviados = dias.map(d => d.substring(0, 3));
  const grupos = [];
  for (let i = 0; i < abreviados.length; i += 3) {
    grupos.push(abreviados.slice(i, i + 3));
  }
  return grupos;
},

    async carregarMaquinas() {
  try {
    const res = await axios.get('/api/maquina', { 
      params: { operacaoId: this.dataset.operation } 
    });
    this.maquinasOpcoes = res.data || [];
  } catch (e) {
    console.error("Erro ao carregar lista de máquinas");
  }
},

getNomeMaquina(id) {
  const maquina = this.maquinasOpcoes.find(m => String(m.id) === String(id));
  return maquina ? maquina.nome : '-';
},

pageChanged(page) {
  this.dataList.options.page = page;
  this.load();
},

pageSizeChanged(size) {
  this.dataList.options.size = size;
  this.load(true);
},

async load() {
  this.dataList.loading = true;
  try {
    const res = await axios.get('/api/preco-dinamico', {
      params: {
        operacaoId: this.dataset.operation,
        page: this.dataList.options.page - 1,
        size: this.dataList.options.size
      }
    });
    this.dataList.data = res.data.content || [];
    this.dataList.count = (res.data.page && res.data.page.totalElements) || res.data.totalElements || 0;
  } catch (error) {
    const msg = (error.response && error.response.data && error.response.data.mensagem) || 'Erro ao carregar dados';
    this.mostrarSnackbar(msg, 'error');
  } finally {
    this.dataList.loading = false;
  }
},

    abrirFormulario: function() {
  this.$router.push('/preco-dinamico/novo');
},

    editarItem: function(item) {
  this.$router.push('/preco-dinamico/' + item.id);
},

    confirmarExclusao: function(item) {
      this.itemParaExcluir = item;
      this.dialogExcluir = true;
    },

 async excluirItem() {
  try {
    await axios.delete('/api/preco-dinamico/' + this.itemParaExcluir.id);
    this.mostrarSnackbar('Preço dinâmico excluído com sucesso!');
    this.loadData();
  } catch (error) {
    const msg = (error.response && error.response.data && error.response.data.mensagem) || 'Erro ao excluir'
    this.mostrarSnackbar(msg, 'error');
  } finally {
    this.dialogExcluir = false;
  }
},

    onSalvo: function() {
      this.dialogFormulario = false;
      this.loadData();
      this.mostrarSnackbar('Preço dinâmico salvo com sucesso!');
    },

    mostrarSnackbar: function(text, color) {
      this.snackbar.text = text;
      this.snackbar.color = color || 'success';
      this.snackbar.show = true;
    }
  }
};
</script>

<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    font-size: 14px;
    font-style: normal;
}
.ga-3 { gap: 24px; }

@media (max-width: 768px) {
/* Selector com .preco-dinamico-table pra não vazar pra tabelas de outras
   telas (esse <style> não é scoped — sem essa classe, valia globalmente). */
.app-table.preco-dinamico-table.v-data-table--mobile .v-data-table__mobile-row {
  padding: 4px 0 !important;
  min-height: auto !important;
}
  .actions-gap-desktop {
    gap: 28px !important;
  }

  .app-table.preco-dinamico-table.v-data-table--mobile tbody tr {
    border-bottom: 2px solid #000 !important;
    margin-bottom: 8px !important;
    padding-bottom: 4px !important;
    display: block !important;
  }

  .app-table.preco-dinamico-table.v-data-table--mobile .v-data-table__mobile-row {
    padding-left: 0 !important;
  }

  .app-table.preco-dinamico-table.v-data-table--mobile .v-data-table__mobile-row__header {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }

.app-table.preco-dinamico-table.v-data-table--mobile table {
    table-layout: auto !important;
    width: 100% !important;
  }

  .app-table.preco-dinamico-table.v-data-table--mobile .v-data-table__mobile-table-row {
    width: 100% !important;
  }

  .app-table.preco-dinamico-table.v-data-table--mobile .v-data-table__mobile-row {
    width: 100% !important;
    display: flex !important;
    justify-content: space-between !important;
  }

  .app-table.preco-dinamico-table.v-data-table--mobile .v-data-table__mobile-row__header {
    flex: 0 0 auto !important;
  }

  .app-table.preco-dinamico-table.v-data-table--mobile .v-data-table__mobile-row__cell {
    text-align: right !important;
  }

  .title-block {
    margin-bottom: 25px !important;
  }

  .app-breadcrumb {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }

  .app-breadcrumb ::v-deep ul,
  .app-breadcrumb ::v-deep .v-breadcrumbs__items {
    padding-left: 0 !important;
  }

  .button-group {
    display: flex !important;
    width: 100% !important;
    gap: 10px !important;
    margin-top: 0 !important;
    margin-bottom: 8px !important;
  }

  .button-group .v-btn {
    flex: 1 !important;
    min-width: unset !important;
  }
}
.action-btn-fixed {
  min-width: 0 !important;
  padding: 0 10px !important;
}

@media (min-width: 769px) {
  .actions-gap-desktop {
    gap: 8px;
  }
}
.app-table.preco-dinamico-table th {
  white-space: normal !important;
}

.app-table.preco-dinamico-table table {
  table-layout: fixed;
}

.lista-custom-pagination {
  flex-direction: column;
  padding: 12px 8px 4px 8px;
  margin-top: 4px;
  border-top: 1px solid #eee;
  gap: 10px;
}

.lista-pagination-topo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.lista-itens-por-pagina {
  max-width: 80px;
  flex: 0 0 auto;
}

.lista-pagination-label {
  font-size: 13px;
  color: #666;
  font-weight: 600;
  white-space: nowrap;
}

.lista-pagination-botoes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.lista-pagination-botoes .v-btn {
  min-width: auto !important;
  padding: 0 8px !important;
  font-size: 12px !important;
  text-transform: none;
}
</style>